const DRAGGABLE_IDENTIFIER = Symbol('draggable-identifer');
function reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
}
export { DRAGGABLE_IDENTIFIER, reorder, };
//# sourceMappingURL=utils.js.map